import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { LanguageService } from '../../../../core/services/language.service';
import { OrganizationApiService } from '../../../../core/modules/organization/organization-api.service';

@Component({
  selector: 'tax-info-individual',
  templateUrl: './info-individual.component.html',
  styleUrls: ['./info-individual.component.sass'],
})

export class InfoIndividualComponent implements OnInit, OnDestroy {
  // @ts-ignore
  @Input() organization;

  // @ts-ignore
  isSameAddress: boolean;
  organizationForms: Array<{ id: number; name: string; shortTitle: string }> = [];

  private destroy$: Subject<void> = new Subject<void>();

  constructor(
    private organizationApiService: OrganizationApiService,
    private languageService: LanguageService,
  ) {}

  ngOnInit(): void {
    this.languageService.languageChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.getOrganisationForms());

    this.isSameAddress = this.organization.actualAddress === this.organization.legalAddress;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  private getOrganisationForms(): void {
    this.organizationApiService.fetchOrganisationTypes()
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => this.organizationForms = response);
  }

  getOrganizationForm(id: string): string {
    if (this.organizationForms.length) {
      const form = this.organizationForms.find(item => item.id === Number(id));
      // @ts-ignore
      return form.name;
    }
    return '';
  }
}
